// extracted by mini-css-extract-plugin
export default {"container":"ResultsView_container__bfJhi","summariesContainer":"ResultsView_summariesContainer__aix1O"};